import { render, staticRenderFns } from "./VScroll.vue?vue&type=template&id=9145d130&scoped=true"
import script from "./VScroll.vue?vue&type=script&lang=js"
export * from "./VScroll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d4iazq3oduqb2szvpffvlcs4f4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9145d130",
  null
  
)

export default component.exports